export default __webpack_public_path__ + "static/media/piratenxhumanisten_quadrat_hell.4ee933c1.svg";